import { StyledVehicleModalCard, StyledVinNumber, StyledText, ArrowContainer } from './styles';
import VehicleIcon from 'assets/AgreementIcons/Vehicle';
import StockNumberIcon from 'assets/stockNumber';
import LicensePlateIcon from 'assets/LicensePlateIcon';
import DisplayArrowBottom from 'assets/DisplayArrowBottom';
import colors from 'styles/colors';

const VehicleModalCard = ({ vehicle }) => (
  <>
    <StyledVehicleModalCard>
      <StyledVinNumber>
        <VehicleIcon color={colors.fleetBlue} /> {vehicle.vin}
      </StyledVinNumber>
      <StyledText>{`${vehicle.model?.make ?? ''} ${vehicle.model?.model ?? ''} ${
        vehicle.model?.year ?? ''
      }`}</StyledText>
      <StyledText>
        {vehicle.stockNumber && <StockNumberIcon color={colors.darkGrayIcon} />}
        {vehicle.stockNumber}
      </StyledText>
      <StyledText>
        {vehicle.licensePlate && <LicensePlateIcon color={colors.darkGrayIcon} />}
        {vehicle.licensePlate}
      </StyledText>
    </StyledVehicleModalCard>
    <ArrowContainer>
      <DisplayArrowBottom />
      <DisplayArrowBottom />
      <DisplayArrowBottom />
    </ArrowContainer>
  </>
);

export default VehicleModalCard;
